/* eslint-disable no-underscore-dangle */
import Vue from 'vue';
import { transformStyle, toLine, toHump } from '@tencent/magic-ui-util';
import scrollMixin from '../../../src/mixins/scroll';
import { spliceNotRenderContainer } from '../../../src/mixins/renderView';

export default {
  name: 'magic-ui-container',

  mixins: [scrollMixin],

  inject: {
    app: {
      default: {},
    },
  },

  props: {
    config: {
      type: [Object],
    },

    model: {
      type: [Array, Object],
    },
  },

  data() {
    return {
      initialized: false,
      visible: true,
      data: {},
    };
  },

  computed: {
    className() {
      if (!this.config) {
        return '';
      }

      let { className } = this.config;
      if (typeof className === 'function') {
        className = className(this, { model: this.model });
      }
      if (Array.isArray(className)) {
        className = [...className];
      } else if (typeof className === 'string') {
        className = [className];
      } else {
        className = [];
      }

      if (!this.inMagic && this.scrollHide) {
        className.push('magic-scroll-hide');
      }

      return className.join(' ');
    },

    style() {
      if (!this.config) {
        return '';
      }

      let style = this.config.style || {};

      if (typeof style === 'function') {
        style = style.bind(this)(this, { model: this.model });
      } else {
        const base = ['Hippy-TV', 'TV'].includes(this.app.pageConfig.pageType) ? 1920 : 375;
        style = transformStyle(style, Vue, this.inHippy, base);
      }

      // 编辑器中容器没有背景色或背景图时，默认一个背景色，便于看到容器的存在
      if (this.inMagic && this.config.type === 'container' && !style.backgroundColor && !style.backgroundImage) {
        style.backgroundColor = 'rgba(51, 153, 255, 0.5)';
      }

      if (!this.visible) {
        style.display = 'none';
      }

      if (style.position === 'fixed' && typeof style.zIndex === 'undefined') {
        style.zIndex = 500;
      }

      return style;
    },

    html() {
      if (!this.config.html) {
        return '';
      }

      try {
        const res = Vue.compile(this.config.html);

        const vue = new Vue({
          data: {
            data: this.data,
            app: this.app,
          },
          render: res.render,
          staticRenderFns: res.staticRenderFns,
          store: this.$store,
        });
        vue.$mount(document.createElement('div'));
        return vue.$el.innerHTML;
      } catch (e) {
        // console.error(e)
      }
    },

    attrs() {
      const attrs = {
        class: `${this.className} magic-ui-container`,
        id: this.config.id,
      };

      return attrs;
    },
  },

  created() {
    if (this.config && this.config.id && this.config.type !== 'page') {
      this.app.addContainer(this);
    }

    if (!this.config.created) {
      this.initialized = true;
    } else if (typeof this.config.created === 'function') {
      Promise.resolve(this.config.created.call(this, this, this.app)).then(() => {
        this.initialized = true;
      });
    }
  },

  beforeMount() {
    typeof this.config.beforeMount === 'function' && this.config.beforeMount.call(this, this, this.app);
  },

  mounted() {
    typeof this.config.mounted === 'function' && this.config.mounted.call(this, this, this.app);
  },

  async destroyed() {
    if (this.config && this.config.id) {
      this.app.removeContainer(this);
    }

    if (typeof this.config.destroyed === 'function') {
      await this.config.destroyed();
    }
  },

  methods: {
    display() {
      const fuc = this.config.display;
      if (typeof fuc === 'function') {
        return fuc.bind(this)(this, { model: this.model });
      }

      if (fuc === false) {
        return fuc;
      }

      return true;
    },

    clickHandler($event) {
      this.$emit('click', $event);
    },

    renderFunc(field, h) {
      if (!field) {
        return '';
      }

      return h(field.name, {
        props: field.props || {},

        attrs: field.attrs || {},

        scopedSlots: field.scopedSlots || {},

        domProps: field.domProps || {},

        on: field.on || {},
      }, (field.children || []).map(item => this.renderFunc(item, h)));
    },

    renderComponent(h, config) {
      const type = config.type || 'text';
      const name = config.renderType === 1 ? 'magic-ui-component' : `magic-ui-${type.replace(/([a-z])([A-Z])/, '$1-$2').toLowerCase()}`;

      const field = {
        name,
        props: {
          config,
          model: this.model,
          ref: 'component',
        },
      };

      return this.renderFunc(field, h);
    },

    getReportDirectives() {
      const directives = [];

      if (this.inMagic) {
        return directives;
      }

      const report = this.config.report || {};

      if (report.module) {
        directives.push({
          name: 'report',
          rawName: 'v-report.module',
          value: report.module,
          expression: 'report.module',
          modifiers: { module: true },
        });
      }

      return directives;
    },
  },

  render(h) {
    if (!this.initialized || !this.app.pageConfig || !this.display()) {
      spliceNotRenderContainer(this, this.config);
      return '';
    }

    const items = this.config.items || [];

    const domProps = {};
    if (this.html) {
      domProps.innerHTML = this.html;
    }

    return h('div', {
      attrs: this.attrs,
      style: this.style,
      on: {
        click: this.clickHandler,
      },
      domProps,
      directives: this.getReportDirectives(),
    }, [this.$slots.pre, ...items.map((item, index) => {
      let ref = '';
      let tagName = '';
      const type = toLine(item.type);

      if (type === 'container' || type.endsWith('pop')) {
        tagName = `magic-ui-${type}`;
        ref = toHump(item.type);
      } else {
        return this.renderComponent(h, item);
      }

      return h(tagName, {
        props: {
          model: this.model,
          config: item,
          ref,
          key: index,
        },
      });
    }), this.$slots.default]);
  },
};
